export class AlertsTransformer {
    static toJson(apiData) {
        return {
            anamnesisAlerts: apiData.anamnesis?.[0] ?? {},
            vitalSignsAlerts: apiData.vital_signs?.[0] ?? null,
            referralAlerts: apiData.referral?.[0] ?? "",
            fileAlerts: apiData.consent_file_count,
            hasDrugs: apiData.habit?.[0]?.drugs ?? false
        };
    }
    static validateVitalSigns(vital) {
        if (!vital)
            return {};
        const result = {};
        const sys = vital.blood_pressure;
        const dia = vital.diastolic_blood_pressure;
        const glu = vital.capillary_blood_glucose;
        const fasting = vital.empty_stomach;
        if (sys < 90 || sys > 120)
            result.blood_pressure = sys;
        if (dia < 60 || dia > 80)
            result.diastolic_blood_pressure = dia;
        const fastingOk = glu >= 70 && glu <= 99 && fasting;
        const nonFastingOk = glu <= 140 && !fasting;
        if (!fastingOk && fasting)
            result.capillary_blood_glucose_empty_stomach = glu;
        if (!nonFastingOk && !fasting)
            result.capillary_blood_glucose = glu;
        return result;
    }
    static vitalSignsToList(vitals) {
        const labels = {
            capillary_blood_glucose_empty_stomach: "Glicemia capilar fuera de rango (en ayunas)",
            capillary_blood_glucose: "Glicemia capilar fuera de rango (sin ayuno)",
            blood_pressure: "Presión sistólica fuera de rango",
            diastolic_blood_pressure: "Presión diastólica fuera de rango"
        };
        return Object.entries(vitals).map(([key, value]) => ({
            label: labels[key],
            value
        }));
    }
    static diseasesToList(json) {
        const { anamnesisAlerts } = json;
        const anamnesisBackground = anamnesisAlerts.anamnesis_background;
        return anamnesisBackground ? anamnesisBackground.map((item) => (item.background.name)) : [];
    }
    static transform(apiData) {
        const json = this.toJson(apiData);
        return {
            raw: apiData,
            data: {
                vitalSigns: this.vitalSignsToList(this.validateVitalSigns(json.vitalSignsAlerts)),
                diseases: this.diseasesToList(json),
            }
        };
    }
}
